module.exports = __webpack_public_path__ + "img/BG_green.b33d1a3c.png";